import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import HiverQueryClientProvider from '../reactQueryClient';
import '@atlaskit/css-reset';
import './index.css';
import '../js/external/gainsight';
import App from './modules/App';

import storeProvider from './storeProvider';

const store = storeProvider.init();

const Main = () => (
    <HiverQueryClientProvider>
        <Provider store={store}>
            <BrowserRouter basename="/signup">
                <App />
            </BrowserRouter>
        </Provider>
    </HiverQueryClientProvider>
);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<Main />);
